import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { DemNetSalesPerspective } from '../netSales/DemNetSalesPerspective';

export const DemForecastDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'netSalesTab', label: 'Net Sales', content: <DemNetSalesPerspective forecastId={entityObj.id} /> }
  ]

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}